import styled from 'styled-components';

export default styled.section`
  padding: 3.25rem ${props => props.theme.padding.inner} 4.4375rem;

  @media (min-width: ${props => props.theme.breakpoints.tablet}) {
    padding: 2.9375rem ${props => props.theme.padding.inner} 5.4375rem;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 5.25rem ${props => props.theme.padding.inner} 6.3125rem;
  }

  .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.container};
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
    }
  }

  .post_small {
    padding: 0 0 2.5rem;

    &:last-child {
      padding-bottom: 0;
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      flex: 1 1 33%;
      max-width: ${props => props.theme.maxWidths.postSmall};
      padding: 0 2.25rem;

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }

    @media (prefers-reduced-motion: no-preference) {
      .isAnimated& {
        opacity: 0;
        transition: all 0.4s ease-in-out;
        transition-delay: 0.4s;
        transform: scale(1.1);
      }
    }

    .active& {
      opacity: 1;
      transform: none;
    }
  }
`;
